"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeById = exports.getTypeByCode = void 0;
function getTypeByCode(allTypes, code, typeName) {
    const lower = code.toLowerCase();
    const found = allTypes.find(t => t.code.toLowerCase() === lower);
    if (!found) {
        throw new Error(`Unable to find ${typeName} with code "${code}"`);
    }
    return found;
}
exports.getTypeByCode = getTypeByCode;
function getTypeById(allTypes, id, typeName) {
    const found = allTypes.find(t => t.id === id);
    if (!found) {
        throw new Error(`Unable to find ${typeName} with id "${id}"`);
    }
    return found;
}
exports.getTypeById = getTypeById;
